import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { CatalogBucket } from "../../../models/CatalogBucket";

type Props = {
	setBucketId: (bucketId: number) => void;
	setShowEditModal: (showEditModal: boolean) => void;
	setShowDeleteModal: (showDeleteModal: boolean) => void;
	setShowCreateModal: (showCreateModal: boolean) => void;
};

export const useBucketsOptionsFunctions = ({
	setBucketId,
	setShowEditModal,
	setShowDeleteModal,
	setShowCreateModal,
}: Props) => {
	const getMenuOptions = (data: CatalogBucket) => {
		let options: MenuOptionType[] = [];
		if (!data) {
			options = options.concat([
				{
					name: "New Bucket",
					key: "new_bucket",
					onClick: () => {
						setShowCreateModal(true);
					},
					icon: <PlaylistAddIcon />,
				},
			]);
		} else {
			options = options.concat([
				{
					name: "New Bucket",
					key: "new_bucket",
					onClick: () => {
						setShowCreateModal(true);
					},
					icon: <PlaylistAddIcon />,
				},
				{
					name: "Edit Bucket",
					key: "edit_bucket",
					onClick: () => {
						if (data.BucketId) {
							setBucketId(data.BucketId);
							setShowEditModal(true);
						}
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Bucket",
					key: "delete_bucket",
					onClick: () => {
						if (data.BucketId) {
							setBucketId(data.BucketId);
							setShowDeleteModal(true);
						}
					},
					icon: <DeleteIcon />,
				},
			]);
		}
		return options;
	};

	return {
		getMenuOptions,
	};
};
